import http from "../http";

class KonvivaService {

    async getCourses() {
        const rqst = await http.post(`konviva/courses/`)
        return rqst.data
    }

    async matricularAluno(data) {
        const rqst = await http.post(`konviva/matricular/`, data)
        return rqst.data
    }
}

const konvivaService = new KonvivaService()

export default konvivaService
